import React from "react";
import PropTypes from "prop-types";
import CustomLink from "@bitComponents/unifiedComponents/CustomLink";
import IconGlyph from "@gcloud-npm/components.icon-glyph";
import { COLOR_DICTIONARY } from "@gcloud-npm/utils.enums.colors";

import "./Header.scss";

const Header = ({ taggingInfo, link, title }) => {
  return (
    <div className="buyProcessHeader">
      <div className="container">
        <div className="buyProcessHeader__logo">
          <CustomLink
            forceExternal
            link={link}
            taggingInfo={taggingInfo}
            accInfo={{
              hiddeAccesible: true,
              title,
              arialogoInfo: title,
            }}
          >
            <span>
              <IconGlyph
                className="movistar-m--size-s"
                id="Movistar"
                kind="m"
                width={38}
                color={COLOR_DICTIONARY.BLUE_MOVISTAR}
                priority
              />
            </span>
            <span>
              <IconGlyph
                className="movistar-m--size-m"
                id="Movistar-letra"
                alt="Movistar-icono"
                kind="m"
                height={26.73}
                width={112}
                color={COLOR_DICTIONARY.BLUE_MOVISTAR}
                priority
              />
            </span>
            <span>
              <IconGlyph
                className="movistar-m--size-l"
                id="Movistar-letra"
                kind="m"
                alt="Movistar-icono"
                height={32}
                width={134}
                color={COLOR_DICTIONARY.BLUE_MOVISTAR}
                priority
              />
            </span>
          </CustomLink>
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  taggingInfo: PropTypes.shape({
    event: PropTypes.string,
    eventType: PropTypes.string,
    componentName: PropTypes.string,
    componentVariation: PropTypes.string.isRequired,
    componentContent: PropTypes.string.isRequired,
    componentProduct: PropTypes.string.isRequired,
    componentPerso: PropTypes.any,
    debug: PropTypes.bool,
    customizerId: PropTypes.string,
  }),
  link: PropTypes.string,
  title: PropTypes.string,
};

Header.defaultProps = {
  taggingInfo: {
    componentContent: "logo-movistar",
    componentName: "header",
    componentProduct: "",
    componentPerso: "",
    componentVariation: "all",
  },
  link: "//app.movistar.es",
  title: "Logo Movistar",
};
export default Header;
